export class ItemClickedEventArgs {
	value: any;
	item: any;

	constructor(value: any, item: any) {
		this.value = value;
		this.item  = item;
	}
}
